<template>
	<div v-if="setup.documents.length">
		<o-section :title="setup.title">
			<template v-if="setup.documents.length > 1">
				<o-alert
					center
					class="filter-alert"
					color="info">
					Utilisez les filtres ci-dessous pour rechercher un {{ setup.documentName }} et l'ouvrir dans un nouvel onglet
				</o-alert>
				<div class="row row--grid">
					<div class="col-sm-6">
						<o-select
							v-if="setup.entitiesOptions.length > 1"
							v-model="setup.selectedEntities"
							multiple
							label="Entités"
							:options="setup.entitiesOptions"
							track-key="id"
							display-key="name"/>
					</div>
					<div class="col-sm-6">
						<o-input
							v-model="setup.search"
							label="Référence de document"/>
					</div>
				</div>
			</template>
		</o-section>

		<o-section
			v-if="setup.entities.length"
			:title="setup.documentName.pluralize(setup.filteredDocuments.length)">
			<o-sticker
				v-for="entity in setup.entities"
				:key="entity.id"
				class="signature-documents-list-item">
				<h4 class="signature-documents-list-item__title">
					{{ entity.name }}
					<small>{{ setup.documentName.pluralize(setup.entityDocuments(entity).length) }}</small>
				</h4>
				<h5 class="signature-documents-list-item__delegate">Représentant légal : {{ entity.delegateName }}</h5>
				<div class="labels">
					<o-label
						v-for="document in setup.entityDocuments(entity)"
						:key="document.id"
						outline
						color="info"
						@click="setup.openDoc(document)">
						{{ document.reference }}
					</o-label>
				</div>
			</o-sticker>
		</o-section>

		<o-alert
			v-else
			color="warning">
			Vous devez sélectionner une ou plusieurs entités ci-dessus
		</o-alert>

		<teleport :to="`#OrionAside-${_aside?.uid}__footer`">
			<o-checkbox
				v-model="setup.termsAcceptation"
				required
				:validation="setup.validator.rule('terms')"
				label="En cochant cette case,
				je reconnais avoir pris connaissance de tous les documents ci-dessus et je certifie l'intégralité des données qui y sont renseignées."/>
			<br>
			<o-section align="stretch">
				<o-button
					color="danger"
					outline
					@click="_aside?.close()">
					Annuler
				</o-button>
				<o-button
					color="success"
					@click="setup.sign()">
					Signer {{ `le ${setup.documentName}`.pluralize(setup.documents.length, false) }}
				</o-button>
			</o-section>
		</teleport>
	</div>
</template>

<script setup lang="ts">
import ContractAsideSignatureClientSetupService from '@/setup/contract/ContractAsideSignatureClientSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(ContractAsideSignatureClientSetupService.props);
const setup = new ContractAsideSignatureClientSetupService(props, _aside);
</script>

<style scoped lang="less">
	@import '@/styles/variables';

.filter-alert {
	margin-bottom: 1rem;
}

.signature-documents-list-item {
	&__title {
		color: var(--grey-darker);
		margin: 0;

		small {
			display: inline-block;
			margin: 0.3rem;
			font-size: 0.75em;
			font-weight: normal;
			color: var(--grey);
		}
	}

	&__delegate {
		margin-top: -0.3rem;
		margin-bottom: 1.25rem;
		font-weight: 400;
	}

  .labels {
    margin: -0.13rem -0.3rem;

    .orion-label {
			margin: 0.13rem 0.3rem;
			cursor: pointer;
    }
  }
}
	</style>
